import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const PageShellStyles = makeStyles({
  outer: {
    width: '100%',
    minHeight: '100dvh',
    backgroundColor: tokens.colorNeutralBackground1,
    boxSizing: 'border-box',
    // 👇 Single source of truth for the top space (24px per your screenshot)
    paddingTop: tokens.spacingVerticalXL, // 24px
    paddingBottom: tokens.spacingVerticalXL,
    paddingLeft: tokens.spacingHorizontalXL,
    paddingRight: tokens.spacingHorizontalXL,
  },
  surface: {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
    maxWidth: '1280px',
    marginInline: 'auto',
    ...shorthands.border(0),
  },
});

export const BusyStyles = makeStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    flexDirection: 'column',
    gap: '16px',
  },
});
